import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

// import Image from 'components/Image';

// import theme from 'styles/theme';
import { Contact } from './SectionContact.styled';

const SectionContact = ({ title, cta, to, isExternalLink, isAnchorLink }) => (
  <Contact>
    <div className="circle-1"></div>
    <div className="circle-2"></div>
    <div className="circle-3"></div>
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-7">
          <h2 className="medium-heading">{title || `Don't be shy, say Hi!`}</h2>
          {isAnchorLink ? (
            <a
              href={to}
              target="_blank"
              rel="noreferrer noopener"
              className="white-btn mt-2"
              onClick={(e) => {
                e.preventDefault();
                if (typeof window !== 'undefined')
                  window.scrollb.scrollIntoView(
                    document.getElementById(to.replace('#', '')),
                  );
              }}
            >
              {cta || 'Contact Us'}
            </a>
          ) : (
            <>
              {isExternalLink ? (
                <a
                  href={to}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="white-btn mt-2"
                >
                  {cta || 'Contact Us'}
                </a>
              ) : (
                <Link
                  to={to || 'https://atc.xyz/contact-us/'}
                  className="white-btn mt-2"
                >
                  {cta || 'Contact Us'}
                </Link>
              )}
            </>
          )}
        </div>
        <div className="col-md-5">
          {/* <div
            className="globe-image"
            style={{
              backgroundImage: 'url("/rotating-globe.gif")',
              backgroundSize: '100%',
              backgroundBlendMode: 'screen',
            }}
          /> */}
        </div>
      </div>
    </div>
  </Contact>
);

SectionContact.propTypes = {
  title: PropTypes.string,
  cta: PropTypes.string,
  to: PropTypes.string,
  isExternalLink: PropTypes.bool,
  isAnchorLink: PropTypes.bool,
};

export default SectionContact;
